import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../../components/SEO';
import './YouthSummitSubPages.css';
import campusTourHero from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/DSC_4604.jpg';
import campusTour2 from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/DSC_4561.jpg';
import campusTour3 from '../../assets/YOCILAB Webiste photos/YOCILAB YOuth Summit/REMS0044.jpg';

const activities = [
  {
    title: 'Career Readiness Sessions',
    desc: 'Helping young people understand career pathways, workplace expectations, and how to build high-demand competencies.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <rect x="2" y="7" width="20" height="14" rx="2"/><path d="M16 7V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v2"/>
      </svg>
    ),
  },
  {
    title: 'Leadership Conversations',
    desc: 'Encouraging young people to lead, serve, and create meaningful impact within their universities and communities.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/><path d="M16 3.13a4 4 0 0 1 0 7.75"/>
      </svg>
    ),
  },
  {
    title: 'Entrepreneurship Talks',
    desc: 'Introducing entrepreneurship and innovation as powerful tools for solving local challenges and creating sustainable livelihoods.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <polyline points="22 7 13.5 15.5 8.5 10.5 2 17"/><polyline points="16 7 22 7 22 13"/>
      </svg>
    ),
  },
  {
    title: 'Opportunity Awareness',
    desc: 'Sharing direct access and application tips for scholarships, fellowships, internships, competitions, and global development programs.',
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10"/><line x1="2" y1="12" x2="22" y2="12"/><path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z"/>
      </svg>
    ),
  },
];

const CampusTour = () => (
  <div className="sub-page">
    <SEO
      title="Campus Tour — YOCILAB Youth Summit 2026"
      description="The YOCILAB Youth Summit Campus Tour brings career talks, leadership workshops, and opportunity awareness to schools and universities across Cameroon."
    />

    {/* HERO */}
    <section className="sub-hero sub-hero--summit">
      <div className="sub-hero__bg">
        <img src={campusTourHero} alt="Campus Tour" className="sub-hero__img" />
        <div className="sub-hero__overlay" />
      </div>
      <div className="container">
        <div className="sub-hero__content">
          <Link to="/youth-summit" className="sub-hero__back">
            ← Back to Summit
          </Link>
          <span className="sub-hero__tag">PRE-SUMMIT PROGRAM</span>
          <h1 className="sub-hero__title">Campus Tour</h1>
          <p className="sub-hero__desc">
            Bringing the Summit to schools, universities, and youth communities across Cameroon — sparking ambition before the main event.
          </p>
          <div className="sub-hero__meta-chips">
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><rect x="3" y="4" width="18" height="18" rx="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
              September – October 2026
            </span>
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z"/><circle cx="12" cy="10" r="3"/></svg>
              Multiple cities
            </span>
            <span className="meta-chip">
              <svg width="13" height="13" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2"><path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2"/><circle cx="9" cy="7" r="4"/><path d="M23 21v-2a4 4 0 0 0-3-3.87"/></svg>
              5,000+ young people reached
            </span>
          </div>
        </div>
      </div>
    </section>

    {/* ABOUT */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-two-col">
          <div className="sub-text">
            <span className="section-label">ABOUT THE CAMPUS TOUR</span>
            <h2 className="sub-section__title">The Summit comes to you first</h2>
            <p className="sub-body">
              Not every young person can easily access the Summit. So we bring the experience to them. In the weeks leading up to the main event, the YOCILAB Youth Summit Campus Tour visits schools, universities, and youth community hubs — bringing inspiration, career talks, workshops, and a glimpse of what is waiting at the Summit.
            </p>
            <p className="sub-body">
              The Campus Tour is designed to reach young people who may not yet know about the Summit or have heard about it but don't yet see themselves as someone who belongs there. We want them to know: they do.
            </p>
            <Link to="/contact" className="sub-cta-link">
              Request a Campus Visit →
            </Link>
          </div>
          <div className="sub-visual">
            <img src={campusTour2} alt="Campus Tour in action" className="sub-img" loading="lazy" />
          </div>
        </div>
      </div>
    </section>

    {/* ACTIVITIES */}
    <section className="sub-section sub-section--light">
      <div className="container">
        <div className="sub-header">
          <span className="section-label">WHAT WE DO</span>
          <h2 className="sub-section__title">Campus Tour Activities</h2>
        </div>
        <div className="sub-grid-4">
          {activities.map((a) => (
            <div key={a.title} className="sub-feature-card">
              <div className="sub-feature-card__icon">{a.icon}</div>
              <h3 className="sub-feature-card__title">{a.title}</h3>
              <p className="sub-feature-card__desc">{a.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>

    {/* PARTNER */}
    <section className="sub-section">
      <div className="container">
        <div className="sub-two-col sub-two-col--reverse">
          <div className="sub-text">
            <span className="section-label">GET INVOLVED</span>
            <h2 className="sub-section__title">Host the Campus Tour</h2>
            <p className="sub-body">
              We are looking for schools, universities, youth organizations, and community groups willing to host a Campus Tour stop in their city or institution. Hosting requires minimal setup — we bring the program, speakers, and materials.
            </p>
            <div className="sub-actions">
              <Link to="/contact" className="sub-btn sub-btn--summit">
                Host the Campus Tour
              </Link>
              <Link to="/contact" className="sub-btn sub-btn--outline-dark">
                Become a Campus Ambassador
              </Link>
            </div>
          </div>
          <div className="sub-visual">
            <img src={campusTour3} alt="Summit community" className="sub-img" loading="lazy" />
          </div>
        </div>
      </div>
    </section>

    {/* NAVIGATION */}
    <section className="sub-nav-strip summit-nav-strip">
      <div className="container">
        <h3 className="sub-nav-strip__title">Explore the Full Summit Experience</h3>
        <div className="sub-nav-strip__grid">
          <Link to="/youth-summit/summit-experience" className="sub-nav-card">
            <span className="sub-nav-card__label">Next</span>
            <span className="sub-nav-card__title">Summit Experience →</span>
          </Link>
          <Link to="/youth-summit/innovation-challenge" className="sub-nav-card">
            <span className="sub-nav-card__label">Then</span>
            <span className="sub-nav-card__title">Innovation Challenge →</span>
          </Link>
          <Link to="/youth-summit/fellowship" className="sub-nav-card">
            <span className="sub-nav-card__label">After</span>
            <span className="sub-nav-card__title">YOCILAB Fellowship →</span>
          </Link>
        </div>
      </div>
    </section>
  </div>
);

export default CampusTour;
